// src/pages/FormPage/index.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import FormRenderer from './FormRenderer';

/**
 * Página principal de renderização de formulários dinâmicos
 * Utiliza parâmetros da URL para carregar conteúdo remoto
 * @returns {JSX.Element}
 */
const FormPage = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const account = query.get('account');
  const project = query.get('project');
  const formid = query.get('formid');
  const token = query.get('token');

  return (
    <FormRenderer
      account={account}
      project={project}
      formid={formid}
      token={token}
    />
  );
};

export default FormPage;
